import React from "react"
import Paypal from "./Paypal"
import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-image"


const query = graphql`
    {
        img1: file(relativePath: {eq: "Team.jpg"}) {
            childImageSharp {
                fluid {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`

const Involved = () => {

  const { img1 } = useStaticQuery(query)

  return (
    <div className="container">
      <div style={{ background: "transparent" }} className="jumbotron">
        <h1 className="text-center">JOIN THE TEAM</h1>
        <h3 className="text-center">VOLUNTEER OPPORTUNITIES</h3>
        <h3 className="text-center">WE ARE LOOKING FOR WILDLIFE ANGELS!</h3>
        <ul className="p-3">
          <li>Do you care about your local wildlife?</li>
          <li>Do you want to help prevent unnecessary animal road collisions?</li>
          <li>Do you want to see safety measures put in place to help protect wildlife from busy roads?</li>
        </ul>
        <p>Be part of a growing network of Wildlife Angels and help us shine a light on a better way for our wild
          friends.</p>
        <p>For more information and to join the team please show your interest via our <a
          href="mailto:safepassageforwildlife@zohomail.com?subject=Enquiry"> email address.</a></p>
      </div>
      <p>Wildlife safety measures can be the difference between life and death for many animals and not forgetting human
        casualties as well. </p>
      <p>Safety measures will help ensure happy animals which then will help prevent habitat fragmentation. </p>
      <p>The type of safety measure does depend on the area and the species for eg; an under pass with flowing water
        would benefit ducks and frogs and other species.</p>
      <p>So please support the campaign by doing your bit for the environment and the wonderful wildlife we share our
        Earth with.</p>
      <Paypal />
      <p className="text-center">Thank you for your support</p>
      <p className="text-center">Safe Passage For Wildlife Team</p>
      <Image fluid={img1.childImageSharp.fluid} className="img-fluid mb-3 mb-lg-0 box-shadow" alt="team" />

    </div>
  )
}

export default Involved